import React, { memo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";

import MyCharacterList from "../MyCharacterList";
import FloatWindow from "components/FloatWindow";

import { useTranslation } from "react-i18next";

const MyCharacterListDrawer = () => {
  const d = useAppDispatch();
  const [t] = useTranslation();
  const open = useAppSelector(
    (state) => store.getAppState(state, "openRoomControlWindows").character.open
  );
  // const width = useAppSelector(store.getMenuWidth);
  const onClose = useCallback(() => {
    d(
      store.appStateMutate((state) => {
        state.openRoomControlWindows.character.open = false;
        state.openRoomControls = null;
      })
    );
  }, [d]);
  // todo
  const onAdd = useCallback(() => {
    d(store.addRoomCharacterWithEdit({}));
  }, [d]);
  return (
    <FloatWindow
      onClose={onClose}
      onAdd={onAdd}
      open={open}
      title={t("マイキャラクター一覧")}
    >
      <MyCharacterList />
    </FloatWindow>
  );
};

export default memo(MyCharacterListDrawer);
